import type { MatchBucket } from "@repo/app-types/entities/matchBucket";
import { DateTime } from "luxon";
import { useMemo, type FC } from "react";
import { TrendChart } from "../../teammatePerformance/trendChart.js";

interface TopicTrendChartProps {
  buckets: readonly MatchBucket[];
}

export const TopicTrendChart: FC<TopicTrendChartProps> = ({ buckets }) => {
  const { data, dateLabels } = useMemo(
    () => ({
      data: buckets.map((b) => b.matchCount),
      dateLabels: buckets.map(
        (b) =>
          DateTime.fromISO(b.bucketStart, { zone: "utc" }).toFormat("MMM d") ??
          "",
      ),
    }),
    [buckets],
  );

  return (
    <TrendChart
      className="h-full min-h-30 flex-1"
      lines={[{ key: "matches", data }]}
      minYRange={1}
      renderValue={(v) => String(v)}
      timeUnit="day"
      showsXAxisLabels
      showsYAxisLabels
      getColorClassName={() => "text-gray-600"}
      getTooltipDateLabel={(index) => dateLabels[index] ?? ""}
    />
  );
};
